export default {
  title: 'Extractos mensuales',
  list: {
    empty_list: {
      title: 'Aún no hay extractos mensuales.',
    },
    fields: {
      month: 'Mes',
      stripe_service_invoice_url: 'Factura de Stripe',
      paypal_service_invoice_url: 'Factura de PayPal',
    },
    button: {
      title: 'Exportar',
    },
  },
  export_modal: {
    title: 'Exportar',
    start_date: {
      title: 'Fecha de inicio',
      placeholder: 'fecha',
    },
    end_date: {
      title: 'Fecha de fin',
      placeholder: 'fecha',
    },
    button: {
      export: 'Exportar',
      close: 'Cerrar',
    },
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
  },
};
